import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

const ActionRequiredAmountField: FC<GridCellProps> = (props) => {
  const { dataItem, field = '' } = props;

  const { displayValue } = useGridCellDisplayValue(props);

  const cost = useMemo(() => dataItem?.[field], [dataItem, field]);
  const isNull = dataItem[field] == null;

  const overridenProps = useMemo(
    () => ({
      ...props,
      className: `${props?.className} ${displayValue !== null && cost < 0 && 'text-red-600'}`,
    }),
    [cost, displayValue, props]
  );

  const formattedValue =
    field !== 'glRemainingInitialBudget'
      ? isNull
        ? '$0.00'
        : displayValue
      : isNull
      ? ''
      : displayValue;

  return (
    <GridCellBase {...overridenProps} title={formattedValue}>
      <p className={'text-right'}>{formattedValue}</p>
    </GridCellBase>
  );
};

export default ActionRequiredAmountField;
